<form [formGroup]="form" class="style-form-default">
    <!-- <div class="style-input-default" data-text="Calle *" [ngClass]="{error: verificateInput('calle')}">
      <input type="text" placeholder="Calle" formControlName="calle">
    </div> -->
   <div> 
     <mat-form-field style="width: 100%;"  appearance="outline">
    <mat-label>Calle</mat-label>
    <input
      type="text"
      formControlName="calle"
      matInput
      placeholder="Calle"
    />
  </mat-form-field>
</div>
    <!-- <div class="style-input-default" data-text="N° Casa/Nombre edificio *" [ngClass]="{error: verificateInput('casa_edificio')}">
      <input type="text" placeholder="N° Casa/Nombre edificio" formControlName="casa_edificio">
    </div> -->
    <div>
      <mat-form-field style="width: 100%;"  appearance="outline">
        <mat-label>N° Casa/Nombre edificio</mat-label>
        <input
          type="text"
          formControlName="casa_edificio"
          matInput
          placeholder="N° Casa/Nombre edificio"
        />
      </mat-form-field>
    </div>
    
    <!-- <div class="style-input-default" data-text="Avenida *" [ngClass]="{error: verificateInput('avenida')}">
      <input type="text" placeholder="Avenida" formControlName="avenida">
    </div> -->
    <div>
      <mat-form-field style="width: 100%;"  appearance="outline">
        <mat-label>Avenida</mat-label>
        <input
          type="text"
          formControlName="avenida"
          matInput
          placeholder="Avenida"
        />
      </mat-form-field>
    </div>
    <!-- <div class="style-input-default" data-text="Piso/N° Apartamento *" [ngClass]="{error: verificateInput('piso_apartamento')}">
      <input type="text" placeholder="Piso/N° Apartamento" formControlName="piso_apartamento">
      
    </div> -->
    <div>
       <mat-form-field style="width: 100%;"  appearance="outline">
      <mat-label>Piso/N° Apartamento</mat-label>
      <input
        type="text"
        formControlName="piso_apartamento"
        matInput
        onlyNumber
        placeholder="Piso/N° Apartamento"
      />
      <mat-error *ngIf="form.get('piso_apartamento').hasError('pattern')"
        >El Piso/N° Apartamento es <strong>invalido</strong></mat-error
      >
    </mat-form-field>
    </div>
   
    <div>
      <mat-form-field style="width: 100%;"  appearance="outline">
        <mat-label>Urbanizacion</mat-label>
        <input
          type="text"
          formControlName="urbanizacion"
          matInput
          placeholder="Urbanizacion"
        />
      </mat-form-field>
    </div>
    <!-- <div class="style-input-default" data-text="Urbanizacion *" [ngClass]="{error: verificateInput('urbanizacion')}">
      <input type="text" placeholder="Urbanizacion" formControlName="urbanizacion">
    </div> -->
    
    <div>
      <mat-form-field style="width: 100%;"  appearance="outline">
        <mat-label>Parroquia</mat-label>
        <input
          type="text"
          formControlName="parroquia"
          matInput
          placeholder="Parroquia"
        />
      </mat-form-field>
    </div>
    <!-- <div class="style-input-default" data-text="Parroquia *" [ngClass]="{error: verificateInput('parroquia')}">
      <input type="text" placeholder="Parroquia" formControlName="parroquia">
    </div> -->
    <div>
      <mat-form-field style="width: 100%;"  appearance="outline">
        <mat-label>Municipio</mat-label>
        <input
          type="text"
          formControlName="municipio"
          matInput
          placeholder="Municipio"
        />
      </mat-form-field>
    </div>
    <!-- <div class="style-input-default" data-text="Municipio *" [ngClass]="{error: verificateInput('municipio')}">
      <input type="text" placeholder="Municipio" formControlName="municipio">
    </div> -->
    <div>
      <mat-form-field style="width: 100%;"  appearance="outline">
        <mat-label>Ciudad</mat-label>
        <input
          type="text"
          formControlName="ciudad"
          matInput
          placeholder="Ciudad"
        />
      </mat-form-field>
    </div>
    <!-- <div class="style-input-default" data-text="Ciudad *" [ngClass]="{error: verificateInput('ciudad')}">
      <input type="text" placeholder="Ciudad" formControlName="ciudad">
    </div> -->
    <div>
      <mat-form-field style="width: 100%;"  appearance="outline">
        <mat-label>Estado</mat-label>
        <input
          type="text"
          formControlName="estado"
          matInput
          placeholder="Estado"
        />
      </mat-form-field>
    </div>
    <!-- <div class="style-input-default" data-text="Estado *" [ngClass]="{error: verificateInput('estado')}">
      <input type="text" placeholder="Estado" formControlName="estado">
    </div> -->
    <div>
      <mat-form-field style="width: 100%;"  appearance="outline">
        <mat-label>Referencia de dirección</mat-label>
        <input
          type="text"
          formControlName="referencia_direccion"
          matInput
          placeholder="Referencia de dirección..."
        />
      </mat-form-field>
    </div>
    <!-- <div class="style-input-default column-complete" data-text="Referencia de dirección *" [ngClass]="{error: verificateInput('referencia_direccion')}">
      <textarea rows="4" placeholder="Referencia de dirección..." formControlName="referencia_direccion"></textarea>
    </div> -->
</form>
